import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { AmazonService } from "../../../services/amazon.service";
import { Seller, SellerStatus } from "../../../objects/amazon/seller";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AmazonProduct } from "../../../objects/amazon/AmazonProduct";
import { AmazonStoreCredentials } from "../../../objects/amazon/AmazonStoreCredentials";
import { BaseResponse } from "../../../objects/common/baseResponse";
import { SearchResponse } from "../../../objects/responses/searchResponse";
import { HTCCodeHelper } from "../../../common/helpers/HTCCodeHelper";
import { ConfigService } from "../../../services/configService";
import { EmailService } from "../../../services/emailService";
import { AmazonSignFormComponent } from "../sign/amazon-sign-form-modal.component";

@Component({
    selector: 'amazon-store-products',
    templateUrl: 'amazon-store-products.component.html',
    moduleId: module.id.toString(),
    styleUrls: [
        '../../../../theme/css/datatable-ms-fix.css'
    ],
    encapsulation : ViewEncapsulation.None
})


export class AmazonStoreProductsComponent implements OnInit {

    public products: Array<AmazonProduct> = Array<AmazonProduct>();
    public selectedProducts: Array<AmazonProduct> = Array<AmazonProduct>();
    public currentStore: AmazonStoreCredentials = new AmazonStoreCredentials();
    public HTCCodeHelper = HTCCodeHelper;

    public readonly headerHeight = 0;
    public readonly rowHeight = 140;

    public isAllSelected: boolean;
    @ViewChild('signModal')
    public signForm: AmazonSignFormComponent;

    public idToBlur: string = "amazon-credentials";

    public hasSignModalShown: boolean = false;

    public config = {
        currentPage: 0,
        itemsPerPage: 10,
        totalItems: 0
    };

    public get currentSeller(): Seller {
        return this.amazonService.seller;
    }

    constructor(public amazonService: AmazonService,
                private route: ActivatedRoute,
                private el: ElementRef,
                public router: Router,
                private configService: ConfigService,
                private emailService: EmailService) {
    }


    ngOnInit() {
        this.currentStore = this.currentSeller.Stores[0];
        this.currentStore.Products = this.route.snapshot.data.products.Items;
        this.config.totalItems = this.route.snapshot.data.products.TotalCount;
        this.checkIfAllProductsSelected(this.currentStore.Products);
    }

    public loadProducts(reset: boolean = false): void {
        this.amazonService.getProducts(this.currentSeller.Id, this.currentStore.Id, this.config.currentPage * this.config.itemsPerPage, this.config.itemsPerPage, false)
            .then((response: BaseResponse<SearchResponse<AmazonProduct>>) => {
                if (reset)
                    this.currentStore.Products = response.Data.Items;
                else
                    this.currentStore.Products.push(...response.Data.Items);

                this.currentStore.Products = [...this.currentStore.Products];

                this.checkIfAllProductsSelected(this.currentStore.Products);

                this.config.currentPage++;
            })
    }

    public onScroll(scrollY: any) {
        if (!scrollY || !scrollY.offsetY)
            return;
        // total height of all rows in the viewport
        const viewHeight = this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;

        if (this.config.currentPage * this.config.itemsPerPage >= this.config.totalItems)
            return;

        if (viewHeight + scrollY.offsetY >= this.currentStore.Products.length * this.rowHeight) {
            this.config.currentPage++;

            this.loadProducts();
        }
    }


    public selectProduct(product: AmazonProduct) {
        product.IsSelected = !product.IsSelected;
        this.amazonService.updateProduct(this.currentSeller.Id, this.currentStore.Id, product);
        this.checkIfAllProductsSelected(this.currentStore.Products);
    }

    public selectAll() {
        let isSelect = false;
        if (!this.checkIfAllProductsSelected(this.currentStore.Products)) {
            isSelect = true;
        }

        this.selectedProducts = [];
        for (let product of this.currentStore.Products) {
            product.IsSelected = isSelect;
            this.selectedProducts.push(product);
            this.isAllSelected = isSelect;

        }

        this.amazonService.updateProducts(this.currentSeller.Id, this.currentStore.Id, this.selectedProducts);
    }

    public userNavigate() {
   //     if (this.amazonService.seller.PoaNumber == SellerStatus.NotStarted && !this.hasSignModalShown) {
            this.signForm.show();
    //    } else {
     //       this.goToCongrats();
      //  }
        this.emailService.sendProductsToBB(this.amazonService.seller.Id, this.currentStore.Id);
    }

    public onModalAction(event: boolean) {
        this.hasSignModalShown = event;
        this.goToCongrats();
    }

    public goToCongrats() {

        this.emailService.sendNotificationToSalesEmail(this.amazonService.seller.Email);
        this.router.navigate(['amazon/info/congratulations']);
        const sellerId = this.amazonService.seller.Id;
        const storeId = this.currentStore.Id;

        // let iframe = document.createElement("iframe");
        // iframe.setAttribute("style", "display:none");
        // iframe.setAttribute("src", `${this.configService.config.AdminUrl}/amazon/info/seller/${sellerId}/store/${storeId}/export`);
        // document.querySelector("body").appendChild(iframe);
    }

    public checkIfAllProductsSelected(products: Array<AmazonProduct>): boolean {
        let selectedProduct = products.find(product => product.IsSelected == false);
        if (selectedProduct) {
            this.isAllSelected = false;
            return false;
        }

        this.isAllSelected = true;
        return true;
    }

}


// WEBPACK FOOTER //
// ./app/components/amazon/products/amazon-store-products.component.ts